<template>
  <form>
    <div class="row">
      <div class="col-lg-9">
        <div class="row">
          <div class="col-lg-8">
            <h4 class="card-title font-weight-bold  mt-3 mb-0">{{$t('medium_grant_ev.diligence__internal')}}</h4>
            <h5 class="card-title font-weight-bold  mt-3 mb-0">{{$t('medium_grant_ev.diligence__internal_sub')}}</h5>
            <table class="mt-2 text-center table-bordered table-full-width" cellpadding="5">
              <tr>
                <th></th>
                <th>{{$t('medium_grant_ev.general__risk_level')}}</th>
                <th>{{$t('medium_grant_ev.diligence__internal_table_a')}}</th>
                <th class="total-score-column">{{$t('medium_grant_ev.general__table_total_score')}}</th>
              </tr>
              <tr class="text-center" :class="{'selected-row': EvaluationForm.model.internal_a === row.value}" v-for="(row, index) in tableInternalA" :key="index">
                <td>
                  <radio name="model.internal_a"
                         :value="row.value"
                         v-model="EvaluationForm.model.internal_a"
                  >
                  </radio>
                </td>
                <td>{{row.value}}</td>
                <td>{{row.text}}</td>
                <td v-if="index === 0" rowspan="4" class="force-bg-white">
                  <h1 class="m-0 p-0">{{EvaluationForm.model.internal_a}}</h1>
                </td>
              </tr>
            </table>
            <div>
              <comment-box :is-editable="EvaluationForm.isEditable" v-model="EvaluationForm.model.comments_records_keeping" :comments="EvaluationForm.model.comments_records_keeping"></comment-box>
            </div>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-lg-8">
            <h5 class="card-title font-weight-bold  mt-3 mb-0">{{$t('medium_grant_ev.diligence__internal_sub2')}}</h5>
            <table class="mt-2 text-center table-bordered table-full-width" cellpadding="5">
              <tr>
                <th></th>
                <th>{{$t('medium_grant_ev.general__risk_level')}}</th>
                <th>{{$t('medium_grant_ev.diligence__internal_table_e')}}</th>
                <th class="total-score-column">{{$t('medium_grant_ev.general__table_total_score')}}</th>
              </tr>
              <tr class="text-center" :class="{'selected-row': EvaluationForm.model.internal_e === row.value}" v-for="(row, index) in tableInternalE" :key="index">
                <td>
                  <radio name="model.internal_e"
                         :value="row.value"
                         v-model="EvaluationForm.model.internal_e"
                  >
                  </radio>
                </td>
                <td>{{row.value}}</td>
                <td>{{row.text}}</td>
                <td v-if="index === 0" rowspan="5" class="force-bg-white">
                  <h1 class="m-0 p-0">{{EvaluationForm.model.internal_e}}</h1>
                </td>
              </tr>
            </table>
            <div>
              <comment-box :is-editable="EvaluationForm.isEditable" v-model="EvaluationForm.model.comments_segregation" :comments="EvaluationForm.model.comments_segregation"></comment-box>
            </div>
          </div>
        </div>

        <div class="row mt-4">
          <div class="col-lg-8">
            <h5 class="card-title font-weight-bold  mt-3 mb-0">{{$t('medium_grant_ev.diligence__outstanding_docs')}}</h5>
            <base-input>
      <textarea
        class="form-control mt-5"
        :placeholder="$t('general.write_here')"
        v-model="EvaluationForm.model.outstanding_doc"
      >
      </textarea>
            </base-input>
          </div>
        </div>

        <upload-file v-model="EvaluationForm.files.diligence.outstanding_doc" :size-limit="EvaluationForm.fileSizeLimit" :is-evaluation="true" :file-data="EvaluationForm.files.diligence.outstanding_doc" :is-editable="EvaluationForm.isEditable" section="diligence.outstanding_doc"></upload-file>

        <div class="col-lg-8">
          <comment-box :is-editable="EvaluationForm.isEditable" v-model="EvaluationForm.model.comments_outstanding" :comments="EvaluationForm.model.comments_outstanding"></comment-box>
        </div>
      </div>

      <div class="col-lg-3">
        <info-right></info-right>
      </div>
    </div>
  </form>
</template>
<script>
  import {EvaluationForm} from "@/services";
  import InfoRight from './InfoRight';
  import {CommentBox} from 'src/components';

  export default {
    components: {
      InfoRight,
      CommentBox
    },
    data() {
      return {
        EvaluationForm,
        tableInternalA: [
          {'value': 0, 'text': this.$i18n.t('medium_grant_ev.diligence__internal_table_a_0')},
          {'value': 2, 'text': this.$i18n.t('medium_grant_ev.diligence__internal_table_a_2')},
          {'value': 4, 'text': this.$i18n.t('medium_grant_ev.diligence__internal_table_a_4')},
        ],
        tableInternalE: [
          {'value': 0, 'text': this.$i18n.t('medium_grant_ev.diligence__internal_table_e_0')},
          {'value': 2, 'text': this.$i18n.t('medium_grant_ev.diligence__internal_table_e_2')},
          {'value': 4, 'text': this.$i18n.t('medium_grant_ev.diligence__internal_table_e_4')},
        ]
      }
    },
    beforeCreate() {
      if(!EvaluationForm.files.diligence) {
        EvaluationForm.files.diligence = {};
      }
    },
    methods: {
      getError(fieldName) {
        return this.errors.first(fieldName);
      },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model);
          return res;
        });
      },
    }
  }
</script>
